import { useRecoilState } from 'recoil';
import { getSubjectId, type Subject, viewTaxRatesPerSubject } from 'venn-state';
import type { TaxRate } from 'venn-api';
import { useCallback, useMemo } from 'react';
import { useWorkspaceTaxSettings } from 'venn-utils';

const DEFAULT_TAX_RATE: TaxRate = {
  fedLtRate: 0,
  fedStRate: 0,
  stateRate: 0,
  niitRate: 0,
  lossCap: 0,
};

export const useTaxRate = (subject: Subject | undefined) => {
  const [taxRatesPerSubject, setTaxRatesPerSubject] = useRecoilState(viewTaxRatesPerSubject);
  const taxSettings = useWorkspaceTaxSettings();
  const workspaceDefaultTaxRates = taxSettings.results;

  const taxRate = useMemo((): TaxRate => {
    return (subject && taxRatesPerSubject?.[getSubjectId(subject)]) ?? workspaceDefaultTaxRates ?? DEFAULT_TAX_RATE;
  }, [taxRatesPerSubject, subject, workspaceDefaultTaxRates]);

  const setTaxRate = useCallback(
    (newTaxRate: TaxRate) => {
      if (!subject) {
        return;
      }
      setTaxRatesPerSubject((current) => {
        const taxRates = current ?? {};
        return {
          ...taxRates,
          [getSubjectId(subject)]: newTaxRate,
        };
      });
    },
    [subject, setTaxRatesPerSubject],
  );

  return [taxRate, setTaxRate] as const;
};
